export default "__VITE_ASSET__CmE8fbsQ__"